import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import { ROUTES } from './config/routes';

// Pages
import LandingPage  from './pages/Landing/LandingPage';
import AuthPage     from './pages/Auth/AuthPage';          // login + signup (toggle)
import ProfilePage  from './pages/Profile/ProfilePage';
// import FeedPage        from './pages/Feed/FeedPage';     // à décommenter quand prêt
// import PostDetailPage  from './pages/Post/PostDetailPage';
import NotFoundPage from './pages/NotFound/NotFoundPage';

// ── Small helper: redirect to profile after login ─────────────────────────
// If user lands on /auth while already logged-in, send them home
const RequireGuest = ({ children }) => {
  const user = localStorage.getItem('user');
  if (user) {
    const { _id } = JSON.parse(user);
    return <Navigate to={`/profile/${_id}`} replace />;
  }
  return children;
};

// ── App ───────────────────────────────────────────────────────────────────
const App = () => (
  <BrowserRouter>
    <ThemeProvider>
      <AuthProvider>
        <Routes>

          {/* ── Public ───────────────────────────────────────────────── */}
          <Route path={ROUTES.HOME} element={<LandingPage />} />

          {/* Auth: /auth (or keep your existing /login route pointing here) */}
          <Route
            path="/auth"
            element={
              <RequireGuest>
                <AuthPage />
              </RequireGuest>
            }
          />

          {/* Legacy /login → redirect to /auth */}
          <Route path={ROUTES.LOGIN}    element={<Navigate to="/auth" replace />} />
          <Route path={ROUTES.REGISTER} element={<Navigate to="/auth" replace />} />

          {/* ── Protected ─────────────────────────────────────────────── */}
          <Route
            path="/profile/:userId"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />

          {/* Uncomment when pages are ready
          <Route path={ROUTES.FEED} element={<ProtectedRoute><FeedPage /></ProtectedRoute>} />
          <Route path={ROUTES.POST} element={<ProtectedRoute><PostDetailPage /></ProtectedRoute>} />
          */}

          {/* ── Fallback ──────────────────────────────────────────────── */}
          <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
          <Route path="*"               element={<Navigate to={ROUTES.NOT_FOUND} replace />} />

        </Routes>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);

export default App;